import './env';

import { createCsrfMiddleware, createStart } from '@tanstack/react-start';

import { authTokenRefreshMiddleware } from './middleware/auth-token-refresh';
import { setupMiddleware } from './middleware/setup';
import { traceFunctionMiddleware, traceMiddleware } from './middleware/trace.middleware';

// Server functions are same-origin RPC endpoints and must be guarded against cross-site (CSRF)
// requests. TanStack Start applies this middleware by default, but only when the app does not
// provide its own `startInstance` — defining one here (for the middleware below) opts out of that
// default, so we re-add it explicitly. Filtered to server functions; router/API requests are
// unaffected. It runs after tracing (so a rejection is captured in the span) but before the auth
// refresh (so a rejected cross-site request never triggers a token refresh).
const csrfMiddleware = createCsrfMiddleware({ filter: (ctx) => ctx.handlerType === 'serverFn' });

export const startInstance = createStart(() => {
  return {
    requestMiddleware: [setupMiddleware, traceMiddleware, csrfMiddleware, authTokenRefreshMiddleware],
    functionMiddleware: [traceFunctionMiddleware],
  };
});
